import intl from 'react-intl-universal';

import { isNil } from '@/utils/number';

interface moneyRulesItem {
  min?: number | string;
  max?: number | string;
  reg?: RegExp;
}

const MIN = 0;
const MAX = 99999.99;
// 整形或者小数点后两位
export const INPUT_DECIMALS_REG = /^(0|[1-9]\d*)(\.\d{1,2})?$/;
export const INPUT_INTEGER_REG = /^(0|[1-9]\d*)$/;

export const getDecimalsDigits = (val) => {
  try {
    const index = val.indexOf('.');
    if (index === -1) {
      return 0;
    }
    return val.substr(index + 1)?.length;
  } catch (error) {
    return 0;
  }
};

let maxDecimalsDigits = 0;
let numberReg = null;
export const isDecimalsFn = () => ({ maxDecimalsDigits, numberReg });

export const getMoneyRulesItem: (values?: moneyRulesItem) => () => {} = (values) => {
  const { min = MIN, max = MAX, reg = INPUT_DECIMALS_REG } = values || {};

  const minDigits = getDecimalsDigits(String(min));
  const maxDigits = getDecimalsDigits(String(max));
  maxDecimalsDigits = minDigits > maxDigits ? minDigits : maxDigits;
  numberReg = reg;

  return () => ({
    validator: (_, val) => {
      // 为空时直接通过不走校验
      if (isNil(val)) {
        return Promise.resolve('');
      }
      if (reg.test(val)) {
        if (Number(val) >= Number(min) && Number(val) <= Number(max)) {
          return Promise.resolve('');
        }
        const isFloat = String(min)?.includes('.') || String(max)?.includes('.');
        return Promise.reject(
          new Error(
            isFloat
              ? intl.get('cmp_input_money_decimal_invalid', {
                  min,
                  max,
                  decimal: maxDecimalsDigits,
                })
              : intl.get('cmp_input_money_integer_invalid', { min, max }),
          ),
        );
      }
      return Promise.reject(new Error(intl.get('cmp_input_money_format_invalid')));
    },
  });
};

// 校验充值金额
export const createRechargeValidator = () => {
  const base: any = getMoneyRulesItem()();
  return (_, val) => {
    return base.validator(_, val).then(() => {
      if (isNil(val)) return '';
      if (Number(val) && val % 100 === 0) return '';
      throw new Error(intl.get('cpm_card_recharge_money_invalid'));
    });
  };
};
